<template>
  <div class="about-page">
    <!-- 页面头部 -->
    <div class="about-header">
      <div class="header-content">
        <h1 class="main-title">CREATE. DESIGN. SHARE.</h1>
        <p class="main-subtitle">
          {{ $t('about.subtitle1') }}
          {{ $t('about.subtitle2') }}
        </p>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="about-content">
      <div class="content-container">
        <!-- 三个核心功能区域 -->
        <div class="features-section">
          <div class="feature-card">
            <div class="feature-content">
              <h3 class="feature-title">{{ $t('about.createTitle') }}</h3>
              <p class="feature-description">
                {{ $t('about.createDesc') }}
              </p>
            </div>
          </div>

          <div class="feature-card">
            <div class="feature-content">
              <h3 class="feature-title">{{ $t('about.designTitle') }}</h3>
              <p class="feature-description">
                {{ $t('about.designDesc') }}
              </p>
            </div>
          </div>

          <div class="feature-card">
            <div class="feature-content">
              <h3 class="feature-title">{{ $t('about.shareTitle') }}</h3>
              <p class="feature-description">
                {{ $t('about.shareDesc') }}
              </p>
            </div>
          </div>
        </div>

        <!-- 加入我们区域 -->
        <!-- <div class="join-section">
          <div class="join-content">
            <h2 class="join-title">加入我们，共同驶向汽车设计的未来。</h2>
            <div class="join-decoration">
              <div class="decoration-line"></div>
              <div class="decoration-dot"></div>
              <div class="decoration-line"></div>
            </div>
          </div>
        </div> -->

        <!-- 关注我们区域 -->
        <div class="follow-section">
          <div class="follow-header">
            <h3 class="follow-title">▌ {{ $t('about.followTitle') }}</h3>
            <p class="follow-subtitle">{{ $t('about.followSubtitle') }}</p>
          </div>
          
          <div class="platform-info">
            <div class="platform-card">
              <div class="platform-content">
                <h4 class="platform-name">{{ $t('about.wechatOfficial') }}</h4>
                <p class="platform-desc">{{ $t('about.wechatOfficialDesc') }}</p>
                <div class="qr-code">
                  <img 
                    :src="wechatOfficialQrUrl" 
                    alt="CarDesignSpace微信公众号二维码"
                    class="qr-image"
                  />
                </div>
              </div>
            </div>

            <div class="platform-card">
              <div class="platform-content">
                <h4 class="platform-name">{{ $t('about.wechatMini') }}</h4>
                <p class="platform-desc">{{ $t('about.wechatMiniDesc') }}</p>
                <div class="qr-code">
                  <img 
                    :src="wechatMiniProgramQrUrl" 
                    alt="CarDesignSpace微信小程序二维码"
                    class="qr-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  computed: {
    wechatOfficialQrUrl() {
      return '/api/cos-asset/%E4%BA%8C%E7%BB%B4%E7%A0%81/CDS-%E5%85%AC%E4%BC%97%E5%8F%B7.jpg'
    },
    wechatMiniProgramQrUrl() {
      return '/api/cos-asset/%E4%BA%8C%E7%BB%B4%E7%A0%81/CDS-%E5%B0%8F%E7%A8%8B%E5%BA%8F.jpg'
    }
  },
  data() {
    return {
      
    }
  },
  mounted() {
    // 设置页面标题
    document.title = this.$t('about.pageTitle') + ' - CarDesignSpace'
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

/* 页面头部样式 */
.about-header {
  background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%);
  color: white;
  padding: 80px 0 60px 0;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.about-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.header-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.main-title {
  font-size: 38px;
  font-weight: 700;
  margin: 0 0 14px 0;
  color: #e03426;
  letter-spacing: 2px;
  text-shadow: 0 2px 4px rgba(224, 52, 38, 0.3);
}

.main-subtitle {
  font-size: 17px;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
  font-weight: 300;
  max-width: 860px;
  margin: 0 auto;
}

/* 主要内容区域 */
.about-content {
  padding: 60px 0;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 功能特性区域 */
.features-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-bottom: 80px;
}

.feature-card {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #e03426, #ff6b6b, #e03426);
  border-radius: 4px 4px 0 0;
}

.feature-card:hover {
  transform: translateY(-8px);
}



.feature-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0 0 15px 0;
  letter-spacing: 1px;
}

.feature-description {
  font-size: 16px;
  line-height: 1.7;
  color: #666;
  margin: 0;
  text-align: justify;
}

/* 加入我们区域 */
.join-section {
  text-align: center;
  margin-bottom: 80px;
  padding: 60px 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
}

.join-content {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.join-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0 0 30px 0;
  line-height: 1.4;
}

.join-decoration {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.decoration-line {
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #e03426, transparent);
  border-radius: 1px;
}

.decoration-dot {
  width: 12px;
  height: 12px;
  background: #e03426;
  border-radius: 50%;
}

/* 关注我们区域 */
.follow-section {
  background: white;
  border-radius: 20px;
  padding: 50px 40px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.follow-header {
  text-align: center;
  margin-bottom: 40px;
}

.follow-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin: 0 0 10px 0;
  letter-spacing: 1px;
}

.follow-subtitle {
  font-size: 18px;
  color: #666;
  margin: 0;
  font-weight: 500;
}

.platform-info {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

.platform-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.platform-card:hover {
  transform: translateY(-4px);
}



.platform-content {
  text-align: left;
}

.platform-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 5px 0;
}

.platform-desc {
  font-size: 14px;
  color: #666;
  margin: 0 0 15px 0;
}

.qr-code {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.qr-image {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  border: 2px solid #f0f0f0;
  transition: all 0.3s ease;
}

.qr-image:hover {
  transform: scale(1.05);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .about-header {
    padding: 60px 0 40px 0;
  }

  .main-title {
    font-size: 30px;
    color: #e03426;
  }

  .main-subtitle {
    font-size: 15px;
  }

  .about-content {
    padding: 40px 0;
  }

  .content-container {
    padding: 0 15px;
  }

  .features-section {
    grid-template-columns: 1fr;
    gap: 30px;
    margin-bottom: 60px;
  }

  .feature-card {
    padding: 30px 20px;
  }



  .feature-title {
    font-size: 20px;
  }

  .feature-description {
    font-size: 15px;
  }

  .join-section {
    margin-bottom: 60px;
    padding: 40px 0;
  }

  .join-title {
    font-size: 24px;
  }

  .follow-section {
    padding: 30px 20px;
  }

  .follow-title {
    font-size: 22px;
  }

  .follow-subtitle {
    font-size: 16px;
  }

  .platform-info {
    gap: 20px;
  }

  .platform-card {
    padding: 20px;
    flex-direction: column;
    text-align: center;
  }

  .platform-content {
    text-align: center;
  }

  .qr-image {
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 480px) {
  .about-header {
    padding: 40px 0 30px 0;
  }

  .main-title {
    font-size: 24px;
    color: #e03426;
  }

  .main-subtitle {
    font-size: 14px;
  }

  .about-content {
    padding: 30px 0;
  }

  .content-container {
    padding: 0 10px;
  }

  .features-section {
    gap: 20px;
    margin-bottom: 40px;
  }

  .feature-card {
    padding: 25px 15px;
  }



  .feature-title {
    font-size: 18px;
  }

  .feature-description {
    font-size: 14px;
  }

  .join-section {
    margin-bottom: 40px;
    padding: 30px 0;
  }

  .join-title {
    font-size: 20px;
  }

  .follow-section {
    padding: 25px 15px;
  }

  .follow-title {
    font-size: 18px;
  }

  .follow-subtitle {
    font-size: 14px;
  }

  .platform-info {
    gap: 15px;
  }

  .platform-card {
    padding: 15px;
  }

  .qr-image {
    width: 80px;
    height: 80px;
  }



  .platform-name {
    font-size: 16px;
  }

  .platform-desc {
    font-size: 12px;
  }
}

/* ===== 资料库风格配色覆盖 ===== */
.about-page {
  min-height: calc(100vh - 60px);
  color: #171511;
  background:
    linear-gradient(90deg, rgba(224, 52, 38, 0.045) 0 1px, transparent 1px),
    linear-gradient(180deg, rgba(224, 52, 38, 0.035) 0 1px, transparent 1px),
    #f6f4ee;
  background-size: 56px 56px;
}

.about-header {
  padding: 42px 0 34px;
  color: #171511;
  background: transparent;
}

.about-header::before {
  display: none;
}

.header-content {
  max-width: 1180px;
  padding: 34px 36px;
  background: rgba(255, 253, 248, 0.94);
  border: 1px solid #29251f;
}

.main-title {
  color: #171511;
  font-size: clamp(34px, 5vw, 64px);
  font-weight: 900;
  line-height: 0.95;
  letter-spacing: -0.06em;
  text-shadow: none;
}

.main-subtitle {
  max-width: 780px;
  color: #70695e;
  font-weight: 500;
}

.about-content {
  padding: 30px 0 56px;
}

.feature-card,
.follow-section,
.platform-card {
  background: #fffdf8;
  border: 1px solid #d9d3c6;
  border-radius: 0;
  box-shadow: none;
}

.feature-card::before {
  height: 3px;
  background: #e03426;
  border-radius: 0;
}

.feature-card:hover,
.platform-card:hover {
  border-color: #e03426;
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(39, 35, 29, 0.14);
}

.feature-title,
.follow-title,
.platform-name {
  color: #171511;
  font-weight: 900;
  letter-spacing: -0.03em;
}

.feature-description,
.follow-subtitle,
.platform-desc {
  color: #70695e;
}

.follow-title {
  color: #e03426;
}

.platform-card {
  background: #faf8f0;
}

.qr-image {
  background: #fffdf8;
  border: 1px solid #29251f;
  border-radius: 0;
}

/* ===== 版面最终优化：统一左右边距与边框节奏 ===== */
.about-page {
  --page-max-width: 1180px;
  --page-gutter: 24px;
}

.about-header,
.about-content {
  width: 100%;
  max-width: calc(var(--page-max-width) + var(--page-gutter) * 2);
  margin: 0 auto;
  padding-right: var(--page-gutter);
  padding-left: var(--page-gutter);
  box-sizing: border-box;
}

.about-header {
  padding-top: 34px;
  padding-bottom: 0;
}

.header-content,
.content-container {
  width: 100%;
  max-width: none;
  margin: 0;
  box-sizing: border-box;
}

.header-content {
  padding: 38px 42px;
}

.main-subtitle {
  margin-right: 0;
  margin-left: 0;
  text-align: left;
}

.about-content {
  padding-top: 0;
  padding-bottom: 56px;
}

.content-container {
  padding: 0;
}

.features-section {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  margin-bottom: 0;
  border-right: 1px solid #d9d3c6;
  border-left: 1px solid #d9d3c6;
  border-bottom: 1px solid #d9d3c6;
}

.feature-card {
  padding: 38px 32px;
  border: none;
  border-right: 1px solid #d9d3c6;
}

.feature-card:last-child {
  border-right: none;
}

.feature-card::before {
  top: 0;
  right: auto;
  bottom: 0;
  width: 4px;
  height: auto;
}

.feature-card:hover,
.platform-card:hover {
  transform: none;
  box-shadow: none;
}

.follow-section {
  padding: 38px 42px 42px;
  border-top: none;
}

.follow-header {
  margin-bottom: 28px;
  text-align: left;
}

.platform-info {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  border: 1px solid #d9d3c6;
}

.platform-card {
  justify-content: center;
  padding: 30px;
  border: none;
  border-right: 1px solid #d9d3c6;
}

.platform-card:last-child {
  border-right: none;
}

.platform-content {
  text-align: center;
}

.qr-code {
  margin-top: 18px;
}

.qr-image {
  width: 132px;
  height: 132px;
}

@media (max-width: 900px) {
  .features-section,
  .platform-info {
    grid-template-columns: 1fr;
  }

  .feature-card,
  .platform-card {
    border-right: none;
    border-bottom: 1px solid #d9d3c6;
  }

  .feature-card:last-child,
  .platform-card:last-child {
    border-bottom: none;
  }
}

@media (max-width: 768px) {
  .about-page {
    --page-gutter: 16px;
  }

  .header-content,
  .feature-card,
  .follow-section {
    padding: 24px 20px;
  }
}

/* 首页同款轻纸面：去掉关于页硬边框线条，使用米色层级统一视觉。 */
.about-page {
  --about-paper: rgba(255, 253, 248, 0.72);
  --about-soft: rgba(238, 236, 227, 0.76);
}

.header-content,
.features-section,
.feature-card,
.follow-section,
.platform-info,
.platform-card,
.qr-image {
  border: none !important;
  box-shadow: none !important;
}

.header-content,
.feature-card,
.follow-section {
  background: var(--about-paper) !important;
}

.platform-info,
.platform-card,
.qr-image {
  background: var(--about-soft) !important;
}

.feature-card::before {
  background: rgba(224, 52, 38, 0.78) !important;
}

.feature-card:hover,
.platform-card:hover {
  background: rgba(224, 52, 38, 0.06) !important;
  transform: none !important;
}

/* 关于页背景参考首页左侧栏的柔和米灰色。 */
.about-page {
  --about-paper: rgba(255, 253, 248, 0.68);
  --about-soft: #eeece3;
  background:
    linear-gradient(90deg, rgba(224, 52, 38, 0.035) 0 1px, transparent 1px),
    linear-gradient(180deg, rgba(224, 52, 38, 0.028) 0 1px, transparent 1px),
    var(--about-soft) !important;
  background-size: 56px 56px !important;
}

.header-content,
.feature-card,
.follow-section {
  background: rgba(255, 253, 248, 0.62) !important;
}

.platform-info,
.platform-card,
.qr-image {
  background: var(--about-soft) !important;
}

.about-page .main-subtitle {
  margin-right: auto !important;
  margin-left: auto !important;
  text-align: center !important;
}
</style>
